// @flow
import { useContext } from 'react';

import ImportXLSContext from './ImportXLSContext';


const useImportXLSData = () => useContext(ImportXLSContext);
export default useImportXLSData;
